// src/app/[city]/services/[category]/[type]/types.ts

export const SUPPORTED_CITIES = [
  'claremore',
  'tulsa',
  'broken-arrow',
  'owasso',
  'catoosa',
  'verdigris',
  'inola',
  'rogers-county',
] as const;

export type CitySlug = (typeof SUPPORTED_CITIES)[number];

export const SUPPORTED_CATEGORIES = ['design-and-build', 'design-and-renovate'] as const;
export type ServiceCategory = (typeof SUPPORTED_CATEGORIES)[number];
